<template>
  <div class="m-image-box">
    <div class="image-container">
      <div v-for="(item, key) in fileList" :key="key" class="image-item">
        <el-image class="img" :src="item.fileUrl" fit="fill" :alt="item.fileName" :preview-src-list="[item.fileUrl]"></el-image>
        <i title="删除" class="el-icon-error image-item__close" @click="handleDelete(item)"></i>
      </div>
      <el-upload v-show=" !(limit === 1 && fileList.length >= 1)" class="file-upload" :headers="userToken" :data="fileData" name="file" :limit="limit" :file-list="fileList" :show-file-list="false" :action="url" :accept="accept" :on-exceed="handleExceed" :before-upload="beforeUpload" :on-success="handleSuccess" :on-error="handleError">
        <i class="el-icon-plus icon"></i>
      </el-upload>
    </div>
    <!-- <div class="tips">
      <div v-if="$slots.tips"><slot name="tips"></slot></div>
      <template v-else>
        <div class="tips__content">
          1.仅支持上传 jpg/png 格式图片，限制大小不超过 1MB，数量少于5个。
        </div>
      </template>
    </div> -->
  </div>
</template>
<script>
/**
 * file-upload 组件
 * 支持jpeg,jpg
 * 附件最多支持同时展示5个附件
 */
export default {
  name: "ImgUpload",
  model: {
    prop: "fileList",
    event: "update:fileList",
  },
  data() {
    return {
      fileData: {
        // userId: this.$store.state.mainData.userId,
        // staffId: this.$store.state.mainData.staffId,
        // organId: this.$store.state.mainData.loginOrganId,
        ownerType: "ORGAN",
        // ownerId: this.$store.state.mainData.loginOrganId,
        productCode: "NYGKPT",
      },
      url: '/api' + this.$API.file_uploadFile,
      userToken: { Authorization: sessionStorage.getItem('token') },
    };
  },
  props: {
    // 文件类型限制
    accept: {
      type: String,
      default: "jpeg,jpg,png",
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 10,
    },
    // 上传文件数量限制
    limit: {
      type: Number,
      default: Infinity,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    acceptFile() {
      return this.accept.length
        ? this.accept.split(",").map((item) => item.toUpperCase())
        : [];
    },
  },
  methods: {
    beforeUpload(file) {
      const name = file.name.split(".");
      const suffix = name[name.length - 1].toUpperCase();

      const isLt = file.size / 1024 / 1024 < this.fileSize;
      if (!this.acceptFile.includes(suffix)) {
        this.$message.error(`文件格式不正确, 请上传${this.accept}格式文件!`);
        return false;
      }
      if (!isLt) {
        this.$message.error(`上传图片大小不能超过 ${this.fileSize}MB!`);
        return false;
      }

      return true;
    },
    handleSuccess(res, file) {
      if (res.success && res.data) {
        this.fileList.push({
          fileUrl: res.data.fileUrl,
          fileName: res.data.fileName,
          fileType: res.data.fileType,
        });
        this.$emit("change", this.fileList);
        this.$emit("callback", false);
      } else {
        this.$message.error(res.message);
      }
    },
    handleError(res) {
      this.$message.error("上传失败");
      this.$emit("callback", false);
    },
    // 删除附件
    handleDelete(item) {
      const index = this.fileList.findIndex((file) => file.fileUrl === item.fileUrl);
      this.fileList.splice(index, 1);
      this.$emit("change", this.fileList);
    },
    // 超出限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制上传 ${this.limit} 个文件`
      );
    },
  },
};
</script>
<style lang="scss">
.m-image-box {
  padding-top: 10px;
  .image-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .image-item {
      width: 100px;
      height: 100px;
      border-radius: 6px 6px 6px 6px;
      border: 1px solid #ccd0d8;
      position: relative;
      margin-right: 16px;
      margin-bottom: 16px;
      .img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
      }
      &__close {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 20px;
        font-size: 20px;
        color: #909399;
        cursor: pointer;
        z-index: 999;
      }
    }
  }
  .file-container {
    margin-top: 20px;
    .file-item {
      display: flex;
      align-content: space-between;
      align-items: center;
      width: 468px;
      margin-top: 10px;
      &__name {
        width: 417px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 14px;
        color: #606266;
        .icon {
          margin-right: 6px;
        }
      }
      &__delete-btn {
        flex: 1;
        text-align: right;
        cursor: pointer;
        .icon {
          font-size: 18px;
          color: #7c8089;
        }
      }
    }
  }
  .file-upload {
    width: 100px;
    height: 100px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #ccd0d8;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    .icon {
      font-size: 32px;
      color: #8c939d;
    }
  }
  .tips {
    font-size: 12px;
    color: #909399;
    line-height: 21px;
  }
}
</style>
